import React, { useEffect, useState } from 'react';
import { HeaderLarger } from './pieces/HeaderLarge';
import { HeaderSmall } from './pieces/HeaderSmall';
import { useSearchParams } from 'react-router-dom';
import { useToken } from '../../store/auth/tokenStore';
import { OwnerReservationsPanel } from '../OwnerReservationsPanel';

export const Header: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [ownerReservationsOpen, setOwnerReservationsOpen] = useState(false);

    useEffect(() => {
      const token = searchParams.get('data');
      if (token) {
        useToken.getState().setToken(token);
        const plainUrl = window.location.origin + window.location.pathname;
        window.history.replaceState(null, "", plainUrl);
      }
    }, [searchParams]);

    return (
        <>
            <HeaderLarger onOpenOwnerReservations={() => setOwnerReservationsOpen(true)} />
            <HeaderSmall onOpenOwnerReservations={() => setOwnerReservationsOpen(true)} />
            <OwnerReservationsPanel
                open={ownerReservationsOpen}
                onClose={() => setOwnerReservationsOpen(false)}
            />
        </>
    );
};
